export class Tags {
  public Types = [];
}
